import { PLATFORM_SHARE_EDIT_SUPPORTED } from '@openx/components-deal/lib/components/EnableDataPartners/constants.ts';
import { useAuth } from '../../../components/AuthContext/context.ts';
import { isAdmin, isInternalUser } from '../../../permissions/validators.ts';

export const useCanEditSegmentPartnerPlatformShare = (): boolean => {
  const { session } = useAuth();

  return PLATFORM_SHARE_EDIT_SUPPORTED && isAdmin(session) && isInternalUser(session);
};
